import { useEffect } from 'react'
import { useStore } from 'store/state/store'
import { bypassKey } from 'src/data/constants'

export default function useBypassTimer({ bypassParam }: { bypassParam?: string }) {
  const bypassValue = bypassParam === 'true' ? true : bypassParam === 'false' ? false : undefined

  const bypass = useStore((state) => state.bypass)
  const setBypass = useStore((state) => state.setBypass)

  const shouldBypass = bypass === bypassKey

  useEffect(() => {
    if (bypassValue !== undefined && shouldBypass !== bypassValue) {
      const update = bypassValue ? bypassKey : ''
      setBypass(update as string)
    }
  }, [bypassValue, shouldBypass, setBypass])
}
